// Suppress noisy console errors from a specific Chrome extension
// Note: Browser network-level messages may still appear in some cases.

(() => {
  const EXT_ID = "pejdijmoenmkgeppbflobdenhhabjlaj";
  const EXT_PREFIX = `chrome-extension://${EXT_ID}/`;

  const shouldIgnore = (value) => {
    if (!value) return false;
    try {
      if (typeof value === "string") return value.includes(EXT_PREFIX);
      if (value instanceof Error) return (value.stack || "").includes(EXT_PREFIX);
      if (typeof value === "object") return JSON.stringify(value).includes(EXT_PREFIX);
    } catch (_) {}
    return false;
  };

  // Patch console methods
  ["error", "warn"].forEach((method) => {
    const original = console[method];
    console[method] = function (...args) {
      if (args.some(shouldIgnore)) return; // drop logs from target extension
      return original.apply(console, args);
    };
  });

  // Global error handlers
  const errorHandler = (event) => {
    const src = event?.filename || event?.message || "";
    const targetSrc = event?.target?.src || event?.target?.href || "";
    const errStack = event?.error?.stack || "";
    if (
      src.includes(EXT_PREFIX) ||
      targetSrc.includes("chrome-extension://") ||
      errStack.includes(EXT_PREFIX)
    ) {
      event.preventDefault?.();
      event.stopImmediatePropagation?.();
      return false;
    }
  };

  const rejectionHandler = (event) => {
    const reason = event?.reason;
    if (shouldIgnore(reason)) {
      event.preventDefault?.();
      event.stopImmediatePropagation?.();
      return false;
    }
  };

  window.addEventListener("error", errorHandler, true);
  window.addEventListener("unhandledrejection", rejectionHandler, true);
})();
